import { render, staticRenderFns } from "./link.component.vue?vue&type=template&id=7bd7f67d&"
import script from "./link.component.vue?vue&type=script&lang=ts&"
export * from "./link.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports